import React from 'react';
import { useTranslation } from 'react-i18next';
import { Download } from 'lucide-react';

function CapacityMarket() {
  const { t } = useTranslation();

  // Mock data - w prawdziwej aplikacji to by przyszło z API
  const obligations = [
    {
      id: 1,
      deliveryYear: 2024,
      auctionType: 'Main Auction',
      obligation: 15.0,
      price: 244.90,
      revenueForecast: 3673500,
      status: 'active'
    },
    {
      id: 2,
      deliveryYear: 2025,
      auctionType: 'Main Auction',
      obligation: 18.0,
      price: 260.00,
      revenueForecast: 4680000,
      status: 'contracted'
    },
    {
      id: 3,
      deliveryYear: 2026,
      auctionType: 'N/A',
      obligation: null,
      price: null,
      revenueForecast: null,
      status: 'pending'
    }
  ];

  const formatNumber = (value, decimals = 2) => {
    if (value === null || value === undefined) return '-';
    return new Intl.NumberFormat('pl-PL', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    }).format(value);
  };

  const formatCurrency = (value) => {
    if (value === null || value === undefined) return '-';
    return new Intl.NumberFormat('pl-PL', {
      style: 'decimal'
    }).format(value) + ' PLN';
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      active: {
        label: t('capacityMarket.status.active'),
        className: 'bg-green-100 text-green-700'
      },
      contracted: {
        label: t('capacityMarket.status.contracted'),
        className: 'bg-blue-100 text-blue-700'
      },
      pending: {
        label: t('capacityMarket.status.pending'),
        className: 'bg-yellow-100 text-yellow-700'
      }
    };

    const config = statusConfig[status];
    return (
      <span className={`px-3 py-1 rounded-full text-xs font-medium ${config.className}`}>
        {config.label}
      </span>
    );
  };

  const handleDownloadCertificates = () => {
    // W prawdziwej aplikacji tutaj byłoby wywołanie API
    console.log('Downloading certificates...');
  };

  return (
    <div className="space-y-4">
      {/* Header */}
      <div className="flex items-start justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 mb-4">{t('capacityMarket.title')}</h1>
          <p className="text-gray-600 text-sm leading-relaxed max-w-2xl">
            {t('capacityMarket.subtitle')}
          </p>
        </div>
        <button
          onClick={handleDownloadCertificates}
          className="flex items-center space-x-2 px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
        >
          <Download className="w-4 h-4" />
          <span>{t('capacityMarket.downloadCertificates')}</span>
        </button>
      </div>

      {/* Table */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t('capacityMarket.table.deliveryYear')}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t('capacityMarket.table.auctionType')}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t('capacityMarket.table.obligation')}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t('capacityMarket.table.price')}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t('capacityMarket.table.revenueForecast')}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {t('capacityMarket.table.status')}
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {obligations.map((obligation) => (
                <tr key={obligation.id} className="hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {obligation.deliveryYear}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                    {obligation.auctionType}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {obligation.obligation !== null ? `${formatNumber(obligation.obligation, 1)} MW` : '-'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {obligation.price !== null ? formatNumber(obligation.price) : '-'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                    {formatCurrency(obligation.revenueForecast)}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    {getStatusBadge(obligation.status)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default CapacityMarket;

